import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store';
import fetchSearchResultsAndPricesOperation from 'store/search/operation/fetchSearchResultsAndPricesOperation';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import getShowRetryModal from 'store/search/selector/getShowRetryModal';
import { showBackdropAction } from 'store/app/slice';
import isBackdropVisible from 'store/app/selector/isBackdropVisible';
import { resetFailedSearchRequestAction, showRetryModalAction } from 'store/search/slice';
import getFailedSearchRequestCount from 'store/search/selector/getFailedSearchRequestCount';
import styles from './RetryFetchSearchResultsModal.module.scss';

const RetryFetchSearchResultsModal = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const showRetry = useSelector(getShowRetryModal);
  const showBackdrop = useSelector(isBackdropVisible);
  const failedRequestCount = useSelector(getFailedSearchRequestCount);

  const retryFetch = () => {
    dispatch(showBackdropAction(false));
    dispatch(fetchSearchResultsAndPricesOperation());
  };

  useEffect(() => {
    if (failedRequestCount === 0) return;
    if (failedRequestCount < 3) {
      retryFetch();
    } else {
      dispatch(resetFailedSearchRequestAction());
      dispatch(showRetryModalAction(true));
    }
  }, [failedRequestCount]);

  useEffect(() => {
    if (showRetry) {
      dispatch(showBackdropAction(true));
    }
  }, [showRetry]);

  useEffect(() => {
    if (showBackdrop) {
      return () => {
        dispatch(showRetryModalAction(false));
      };
    }
    return () => {};
  }, [showBackdrop]);

  if (!showRetry) return null;

  return (
    <div className={styles.container}>
      <div>
        <OpText variant="title-large-bold">{t('errorBoundary.main_text')}</OpText>
      </div>
      <OpButton variant="primary" onClick={retryFetch}>
        {t('txt_retry')}
      </OpButton>
    </div>
  );
};

export default RetryFetchSearchResultsModal;
